import { getTenantRoleSelectOptions } from '@infuse/api/iam/tenant';
import { useGenericRoleSelectOptions } from '@infuse/iam/role/queries';
import { ref } from 'vue';

export const useTenantRoleSelectOptions = () => {
  const fetchTenantId = ref<string | undefined>();

  return {
    ...useGenericRoleSelectOptions({
      apiFn: getTenantRoleSelectOptions,
      queryKeys: ['roles', 'tenant', 'selectOptions'],
      fetchParentId: fetchTenantId,
      onlyEnableWithParentId: true
    }),
    fetchTenantId
  };
};
